// 展示附件读取现有剧本/标记定义，不维护第二套Token数据库。
export const NIGHT_PROMPTS = [
  "你是",
  "这名玩家是",
  "展示角色",
  "你需要对这个角色疯狂",
  "这些角色不在场",
  "这些角色在场",
  "他是恶魔",
  "他们是你的爪牙",
  "他是爪牙",
  "你的阵营是善良",
  "你的阵营是邪恶",
  "镇民",
  "外来者",
  "爪牙",
  "该角色的能力对你生效",
  "这名玩家选择了你",
  "你今天提名了吗",
  "你今天投票了吗",
  "是",
  "否",
  "错误",
  "无",
];
export const MAX_PROMPT_TOKENS = 12;
export function trustedPromptRole(role, base, options = {}) {
  const item = { ...role };
  const safe = (value) => {
    if (typeof value !== "string" || !value.trim()) return "";
    if (/^data:image\/(png|jpeg|webp|gif);base64,[a-z0-9+/=]+$/i.test(value))
      return value;
    try {
      const u = new URL(value, base);
      return ["https:", "http:"].includes(u.protocol) &&
        (u.origin === new URL(base).origin || options.isImageOptIn || item.isAdmin)
        ? u.href
        : "";
    } catch {
      return "";
    }
  };
  item.image = Array.isArray(item.image)
    ? item.image.map(safe).filter(Boolean)[0] || ""
    : safe(item.image);
  return item;
}
export function scriptReminderTokens(state) {
  const result = [];
  const add = (role, names, scope) =>
    (Array.isArray(names) ? names : []).forEach((name, index) =>
      result.push({
        key: scope + ":" + role.id + ":" + index,
        role: role.id,
        image: role.image,
        imageAlt: role.imageAlt,
        team: role.team,
        isAdmin: !!role.isAdmin,
        name,
        roleName: role.name || role.id,
      }),
    );
  state.roles.forEach((role) => {
    add(role, role.reminders, "role");
    add(role, role.remindersGlobal, "global");
  });
  state.players.fabled.forEach((role, index) =>
    add(role, role.reminders, "fabled-" + index),
  );
  state.otherTravelers.forEach((role) => {
    if (state.players.players.some((p) => p.role.id === role.id))
      add(role, role.reminders, "traveler");
  });
  ["善良", "邪恶", "自定义提示"].forEach((name, index) =>
    result.push({
      key: "common:" + index,
      role: ["good", "evil", "custom"][index],
      name,
      roleName: "通用",
    }),
  );
  return result;
}
